import { Button, Form, Input } from 'antd';
import { FormInstance } from 'antd/lib/form';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { IFormProps } from '../../typings';

import styles from './PreviewCampaignImageForm.module.less';

export interface PreviewCampaignImageFormProps extends IFormProps {
  form: FormInstance;
}

export function PreviewCampaignImageForm({ form, loading, ...rest }: PreviewCampaignImageFormProps) {
  const { t } = useTranslation();

  return (
    <>
      <Form form={form} className={styles['form']} layout="inline" {...rest}>
        <Form.Item name="sample" className={styles['input']}>
          <Input placeholder={t('SAMPLE_NAME_PLACEHOLDER') as string} disabled={loading} />
        </Form.Item>
        <Form.Item className={styles['btn']}>
          <Button type="primary" htmlType="submit" disabled={loading}>
            {t('PREVIEW_BUTTON')}
          </Button>
        </Form.Item>
      </Form>
      <div className="ant-form-item-extra">{t('PREVIEW_HELP')}</div>
    </>
  );
}
